module.exports = __webpack_public_path__ + "img/dhht-6.7a05dfe0.png";